export default __webpack_public_path__ + "media/images/mailer/icon_lock_open-8e5ae4f888e6ea016e3046b607314d02.png";